module.exports = __webpack_public_path__ + "img/V-45-ST-1000-BE.8c943ec5.png";